"use client";

import { cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "../lib/utils";

const textareaVariants = cva(
  "flex min-h-[60px] w-full rounded-md border border-input bg-card px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
);

// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- lint-backlog: empty type kept as an extension point; changing it can alter assignability
interface TextareaProps extends React.ComponentProps<"textarea"> {}

/**
 * shadcn/ui docs: https://ui.shadcn.com/docs/components/textarea
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(textareaVariants(), className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea, type TextareaProps };
